<template>
  <div>
    <span v-if="contentObj">
      <div class="mobile-w-100 more-info-container">
        <a class="mobile-on mobile-lefted-2" @click="$router.back()">
          <div class="mobile-back-btn Arrow-Macro"></div>
        </a>
        <h1 class="mobile-profile-sub-header">
          {{ contentObj.title }}
        </h1>

        <div class="row">
          <div class="col-xs-12 campaign-content" v-html="contentObj.content"></div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
  import { name as pkgName } from '~/package.json'
  export default {
    head() {
      return {
        title: [this.contentObj?.title, '-', pkgName].join(' '),
        meta: [{ name: 'robots', content: 'noindex' }],
      }
    },
    scrollToTop: true,
    components: {},

    created() {
      if (this.contentObj == undefined || !this.contentObj) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('fetch_single_static_content', 23)
          resolve()
        })
      }
    },
    async asyncData({ store }) {
      let contentData = await store.dispatch('fetch_single_static_content', 23)

      return {
        contentObj: contentData,
      }
    },
    fetch(context) {
      return new Promise((resolve, reject) => {
        context.store.dispatch('fetch_static_content')
        resolve()
      })
    },

    data() {
      return {
        subHeader: this.$t('components.sub.navigation.about'),
      }
    },
  }
</script>
<style scoped>
  p {
    font-size: 15px;
    color: #8a8a8a;
    line-height: 21px;
  }
</style>
